<template>
  <div class="">
    <button
      type="button"
      class="btnEntrance"
      @click.stop="toEntrancePage()">
    </button>
    <div class="title mb30">
      <h2 v-if="infoData && infoData.title[ln]" class="preWrap">{{ infoData && infoData.title[ln] }}</h2>
      <h2 v-else class="notranslate">{{ locale.waiting_info_input }}</h2>
      <p v-if="infoData && infoData.desc[ln]" class="preWrap">{{ infoData && infoData.desc[ln] }}</p>
      <p v-else class="preWrap notranslate">{{ locale.input_telephone_or_email }}</p>
    </div>
    <div class="infoBox">
      <div class="formBox">
        <!-- phone -->
        <div v-if="isRequiredInput('phone')" class="mb10 telInputWithSearch notranslate">
          <label class="label toCapitalize">{{locale.telephone}}</label>
          <div class="inputFrame">
            <div v-show="openCountry" class="searchCountry">
              <input
                type="text"
                class="input"
                placeholder="country name or code"
                ref="searchChatCountryInput"
                v-model="searchCountry"
                @focus.stop
                @click.stop />
              <button type="button" class="btn btnPrimary btnSearch" @click.stop="setSearchCountry">
                {{locale.search}}
              </button>
            </div>
            <vue-tel-input
              class="telInput input mt5"
              ref="telInput"
              v-model="phone"
              :mode="'national'"
              :autoDefaultCountry="true"
              :preferredCountries="filteredCountry"
              :validCharactersOnly="true"
              @input="inputTel"
              @open="toggleCountry(true)"
              @close="toggleCountry(false)">
            </vue-tel-input>
            <button v-if="isPhoneValid && !isPhoneValid.isEmpty" type="button" class="btnClear" @click="phone = ''"></button>
          </div>
          <p v-if="!isPhoneValid.isEmpty && !isPhoneValid.isValid"
            class="inputMessage colorRed">{{ locale.message_correct_format }}</p>
        </div>
        <!-- //phone -->
        <!-- email -->
        <div v-if="isRequiredInput('email')" class="formGroup mb15 notranslate">
          <label class="label toCapitalize">{{ locale.email }}</label>
          <div class="inputFrame">
            <input
              type="email"
              class="input"
              :placeholder="locale.email"
              v-model="email" />
              <button v-if="isEmailValid && !isEmailValid.isEmpty" type="button" class="btnClear" @click="email = ''"></button>
          </div>
          <p v-if="!isEmailValid.isEmpty && !isEmailValid.isValid"
            class="inputMessage colorRed">{{ locale.message_correct_format }}</p>
        </div>
        <!-- //email -->
        <div v-if="!isAgreeTnc" class="message colorRed mb15">
          <div v-if="tnc && tnc.title[ln]">{{ tnc.title[ln] }} <span class="notranslate">- {{ locale.message_agree }}</span></div>
          <div v-else class="notranslate">{{ locale.message_agree_tnc }}</div>
        </div>
        <div v-if="tnc" class="tnc">
          <div v-if="tnc.title[ln]" class="preWrap tncTitle">{{ tnc.title[ln] }}</div>
          <div v-else class="tncTitle notranslate">{{ locale.tnc_title }}</div>
          <div class="checkbox notranslate mb10">
            <input type="checkbox" id="agree_tnc" v-model="agreeTnc">
            <label for="agree_tnc">{{ locale.i_agree }}</label>
          </div>
          <div v-if="tnc.desc[ln]" class="preWrap tncDesc">{{ tnc.desc[ln] }}</div>
          <div v-else class="tncDesc notranslate">{{ locale.tnc_title }}</div>
        </div>
        <div class="formGroup notranslate">
          <button
            type="button"
            class="btn btnRound btnFull"
            :disabled="!validate"
            @click="confirm">
            {{ locale.do_apply }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
    <LanguageList v-if="selectLang"
      :locale="locale"
      :required="true"
      @close="selectLang = false" />
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'
import LanguageList from '../Util/LanguageList.vue'

let timeoutId

export default {
  props: [
    'ln',
    'locale',
    'isPublic',
    'translateType',
    'info',
    'spaceCodeName',
    'nationality'
  ],
  components: {
    Toast,
    LanguageList
  },
  computed: {
    isNoTranslate () { // 자동번역 언어이면 에디터 값을 무시? 일단 데이터는 전달해둠
      return this.translateType !== 'auto'
    },
    infoData () {
      return this.info && this.info.auth
    },
    tnc () {
      return this.info && this.info.tnc
    },
    spaceCode () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.spaceCode
    },
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    },
    isPhoneValid () {
      const phone = this.phone
      const isEmpty = this.isEmpty(regExp.replaceAllEmpty(phone))
      const isValid = this.validatePhone && this.validatePhone.valid
      return {
        isEmpty: isEmpty,
        isValid: isValid,
        result: !isEmpty && isValid
      }
    },
    isEmailValid () {
      const email = this.email
      const pattern = regExp.expEmail
      const isEmpty = this.isEmpty(regExp.replaceAllEmpty(email))
      const isValid = pattern.test(email)
      return {
        isEmpty: isEmpty,
        isValid: isValid,
        result: !isEmpty && isValid
      }
    },
    isAgreeTnc () {
      return this.agreeTnc
    },
    validate () {
      return this.isAgreeTnc && (this.isPhoneValid.result || this.isEmailValid.result)
    },
    entranceActive () {
      return this.info && this.info.setting && this.info.setting.entranceActive
    },
    confirmMessage () {
      const confirm = this.info && this.info.confirm
      const ln = this.ln
      return confirm ? {
        confirm: confirm.confirm[ln],
        complete: confirm.waitingcall_result_complete[ln],
        already: confirm.waitingcall_result_already[ln]
      } : null
    }
  },
  watch: {
    info (data) {
      if (data) {
        this.setLang()
      }
    }
  },
  beforeDestroy () {
    clearTimeout(timeoutId)
  },
  async mounted () {
    this.init()
    this.$nextTick(() => {
      this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
    })
  },
  data () {
    return {
      phone: '',
      email: '',
      message: null,
      openCountry: false,
      searchCountry: '',
      countryList: [],
      validatePhone: {},
      phoneObj: null,
      agreeTnc: false,
      toastList: [],
      toastMessage: null,
      selectLang: false
    }
  },
  methods: {
    init () {
      this.phone = ''
      this.email = ''
      this.toastList = []
      this.toastMessage = null
      this.selectLang = this.nationality === 'foreign'
    },
    setLang () {
      const setting = this.$store.getters['common/getSetting']
      const defaultLang = setting && setting.lang.default
      const info = this.info && this.info.auth
      const authLang = this.nationality === 'foreign'
        ? (info && info.foreignLang) || 'en'
        : (info && info.domesticLang) || defaultLang
      this.$router.replace({
        params: {
          ...this.$route.params,
          ln: authLang || this.ln
        }
      })
    },
    isRequiredInput (input) { // phone, email
      const nationality = this.nationality
      const required = this.infoData && this.infoData[nationality]
      return required && required.includes(input)
    },
    isEmpty (str) {
      return regExp.replaceAllEmpty(`${str}`).length < 1
    },
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchChatCountryInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      this.phoneObj = telObj.number
    },
    setSearchCountry () {
      const value = this.$refs.searchChatCountryInput.value
      this.searchCountry = value
    },
    getResultData (code) {
      return this.$store.getters['waitingcall/getWaitingcallResultData'](code)
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'apply') {
            this.apply()
          } else if (trigger === 'complete') {
            this.delToast()
            this.toEntrancePage()
          } else if (trigger === 'close') {
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    toEntrancePage () {
      const entranceActive = this.entranceActive
      const entranceUrl = this.info && this.info.setting && this.info.setting.entranceUrl
      if (entranceActive) {
        const ln = this.info && this.info.auth && this.info.auth.domesticLang
        const setting = this.$store.getters['common/getSetting']
        const defaultLang = setting && setting.lang.default
        this.$router.push({
          name: 'page',
          params: {
            ln: ln || defaultLang,
            id: entranceUrl.pageId
          }
        })
      } else {
        this.$router.push({
          name: 'waitingcallNationality'
        })
      }
    },
    confirm () {
      const authType = this.isPhoneValid.result
        ? 'telephone'
        : this.isEmailValid.result
          ? 'email'
          : null
      const authData = authType === 'telephone'
        ? this.validatePhone.formatted
        : this.email
      const confirmData = `${this.locale.contact_method}: ${authData}`
      this.addToast('apply', 'confirm',
        (this.confirmMessage && this.confirmMessage.confirm) || `${this.locale.confirm_apply_data}`,
        {
          ...this.spaceCodeName && {
            emMessage: this.spaceCodeName
          },
          emMessage2: confirmData,
          confirmTxt: this.locale.registration
        })
    },
    async apply () {
      const authType = this.isPhoneValid.result
        ? 'phone'
        : this.isEmailValid.result
          ? 'email'
          : null
      const authData = authType === 'phone'
        ? this.validatePhone.number
        : this.email
      const isPublic = this.isPublic
      if (authType && this.validate) {
        const data = {
          spaceCode: this.spaceCode,
          authType: authType,
          authData: authData
        }
        this.$store.commit('loading', true)
        const auth = await this.$store.dispatch('waitingcall/authWaiting', data)
        let applyData = {
          userLanguage: this.$route.params.ln,
          spaceCode: this.spaceCode,
          sendMethod: {
            [authType]: authData
          }
        }
        if (auth && auth.status && auth.status === 200) {
          const authResult = auth.data && auth.data.message
          if (authResult && authResult.rid) {
            const reservedData = {
              rid: authResult.rid,
              name: authResult.name
            }
            applyData = {
              ...applyData,
              ...reservedData
            }
          } else if (authResult.code && authResult.code === 201 && authResult.message && authResult.message.rid) {
            // 이미 등록된 정보
            if (isPublic) {
              this.addToast('complete', 'alert',
                this.locale.return_first_page,
                {emMessage: (this.confirmMessage && this.confirmMessage.already) || this.locale.alert_waiting_already_apply})
              this.$store.commit('loading', false)
              timeoutId = setTimeout(() => {
                this.toEntrancePage()
              }, 7000)
              return
            } else {
              this.addToast('close', 'alert', (this.confirmMessage && this.confirmMessage.already) || this.locale.alert_waiting_already_apply)
              this.$store.commit('loading', false)
              return
            }
          }
        }
        this.$store.commit('loading', true)
        const apply = await this.$store.dispatch('waitingcall/requestWaiting', applyData)
        if (apply && apply.status && apply.status === 200) {
          if (isPublic) {
            // 등록완료
            this.addToast('complete', 'alert',
              (this.confirmMessage && this.confirmMessage.complete) || `${this.locale.waitingcall_complete_apply}\n${this.locale.waitingcall_call_soon}`,
              {
                ...this.spaceCodeName && {
                  emMessage: this.spaceCodeName
                }
              })
            this.$store.commit('loading', false)
            timeoutId = setTimeout(() => {
              this.toEntrancePage()
            }, 7000)
          } else {
            const sendResult = apply.data && apply.data.message
            this.$store.commit('loading', false)
            if (sendResult && sendResult.rid) {
              this.$router.push({
                name: 'waitingcallResult',
                params: {
                  rid: sendResult.rid
                }
              })
            }
          }
        } else {
          const errorCode = apply && apply.message && apply.message.code || 500
          const errorMessage = this.getResultData(errorCode)
          const reason = apply && apply.message && apply.message.reason
          alert(this.locale[`alert_waitingcall_${errorMessage}`] + (reason ? `\n${reason}` : ''))
          this.$store.commit('loading', false)
        }
      }
    },
    
  }
}
</script>
